export enum PaymentTimingType {
    ONE_TIME = 'one-time',
    SCHEDULED = 'scheduled'
}
